//react , compnents
import { withRouter } from 'react-router-dom';
import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//constants
import { PATHS } from '../../Constants'

class LandingAppContainer extends React.Component {
	componentDidMount() {
		this.props.history.push(PATHS.LOGIN)
	}
	render() {
		return <div></div>
	}
}

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{},
		dispatch
	);
};

export default withRouter(
	connect(null, mapDispatchToProps)(LandingAppContainer))